import { UserRole } from "tm-shared/types";

export interface MyRouteCapabilities {
    canSeeDebtMarker: boolean;
}

const MY_ROUTE_CAPABILITIES_BY_ROLE: Partial<
    Record<UserRole, MyRouteCapabilities>
> = {
    [UserRole.Ta]: {
        canSeeDebtMarker: true,
    },
    [UserRole.Md]: {
        canSeeDebtMarker: false,
    },
};

export const getMyRouteCapabilities = (role: UserRole): MyRouteCapabilities => {
    const capabilities = MY_ROUTE_CAPABILITIES_BY_ROLE[role];

    if (!capabilities) throw new Error("this page not allow for your role");

    return capabilities;
};
